import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Services() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" className="px-6 md:px-12 lg:px-24 py-32 md:py-48" data-testid="services-section">
      <p className="font-body text-xs uppercase tracking-[0.25em] text-neutral-500 mb-12">(03) — Services</p>
      <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-16 md:mb-24 max-w-4xl">
        What I do, and how I <span className="font-serif-italic font-normal">show up</span>.
      </h2>

      <div className="border-t border-neutral-300">
        {items.map((s, i) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="border-b border-neutral-300 py-10 md:py-14 grid grid-cols-12 gap-4 group hover:bg-white transition-colors duration-500"
            data-testid={`service-row-${i}`}
          >
            <div className="col-span-2 md:col-span-1 font-body text-xs uppercase tracking-[0.2em] text-neutral-500">
              {s.number}
            </div>
            <div className="col-span-10 md:col-span-5">
              <h3 className="font-display font-bold text-3xl md:text-5xl tracking-tight">{s.title}</h3>
            </div>
            <div className="col-span-12 md:col-span-5 md:col-start-8 font-body text-base text-neutral-700 mt-4 md:mt-0">
              {s.description}
            </div>
            <div className="col-span-12 md:col-span-1 flex items-start justify-end mt-4 md:mt-0">
              <span className="font-display text-2xl text-[#FF3E00] transition-transform duration-500 group-hover:rotate-45">→</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
